(function () {
  if (window.CustomCartUpsellsInit) return;
  window.CustomCartUpsellsInit = true;

  var SWIPER_CSS_URL = "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css";
  var SWIPER_JS_URL = "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js";
  var swiperLoadingPromise = null;
  var upsellDropupCounter = 0;

  function ensureSwiperLoaded() {
    if (window.Swiper) return Promise.resolve();
    if (swiperLoadingPromise) return swiperLoadingPromise;

    swiperLoadingPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector("link[data-upsells-swiper-css]")) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = SWIPER_CSS_URL;
        link.setAttribute("data-upsells-swiper-css", "1");
        document.head.appendChild(link);
      }

      if (document.querySelector("script[data-upsells-swiper-js]")) {
        var t = 0;
        var iv = setInterval(function () {
          t += 50;
          if (window.Swiper) {
            clearInterval(iv);
            resolve();
          }
          if (t > 8000) {
            clearInterval(iv);
            reject(new Error("Swiper load timeout"));
          }
        }, 50);
        return;
      }

      var s = document.createElement("script");
      s.src = SWIPER_JS_URL;
      s.async = true;
      s.setAttribute("data-upsells-swiper-js", "1");
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error("Failed to load Swiper")); };
      document.head.appendChild(s);
    });

    return swiperLoadingPromise;
  }

  function getDrawerEl() {
    return (
      document.querySelector("[data-cart-drawer]") ||
      document.querySelector("#cart-drawer") ||
      document.querySelector(".quick-cart__wrapper") ||
      document.querySelector(".quick-cart") ||
      document.querySelector(".mini-cart__inner") ||
      null
    );
  }

  function getUpsellsRoot() {
    var drawer = getDrawerEl();
    if (drawer) {
      var r = drawer.querySelector("[data-cart-upsells-root]");
      if (r) return r;
    }
    return document.querySelector("[data-cart-upsells-root]");
  }

  function getQuickCartItemsEl() {
    var drawer = getDrawerEl();

    if (!drawer) {
      return (
        document.querySelector("[data-cart-form]") ||
        document.querySelector("[data-cart-wrapper]") ||
        document.querySelector(".quick-cart__items")
      );
    }

    return (
      drawer.querySelector("[data-cart-form]") ||
      drawer.querySelector("[data-cart-wrapper]") ||
      drawer.querySelector(".quick-cart__items") ||
      document.querySelector("[data-cart-form]") ||
      document.querySelector("[data-cart-wrapper]") ||
      document.querySelector(".quick-cart__items")
    );
  }

  function getCartDrawerBody() {
    var drawer = getDrawerEl();

    return (
      (drawer && drawer.querySelector("[data-cart-drawer-body]")) ||
      document.querySelector("[data-cart-drawer-body]")
    );
  }

  function getCartWrapper() {
    var drawer = getDrawerEl();

    return (
      (drawer && drawer.querySelector("[data-cart-wrapper]")) ||
      document.querySelector("[data-cart-wrapper]")
    );
  }

  function getCartSectionId() {
    var wrapper = getCartWrapper();
    return (wrapper && wrapper.getAttribute("data-section")) || "ajax-cart";
  }

  function safeCall(fnName, arg) {
    if (typeof window[fnName] === "function") {
      try {
        return window[fnName](arg);
      } catch (e) {}
    }
  }

  function reinitCartDrawer(cartBody, itemCount) {
    if (!cartBody) return;

    if (typeof window.cartCountUpdate === "function") {
      try { window.cartCountUpdate(itemCount || 0); } catch (e) {}
    } else {
      document.querySelectorAll("[data-header-cart-count]").forEach(function (el) {
        el.textContent = itemCount > 0 ? String(itemCount) : "";
        el.classList.toggle("hidden", !(itemCount > 0));
      });
    }

    safeCall("getQuantityElement", cartBody);
    safeCall("getCartItemRemoveElements", cartBody);
    safeCall("cartNoteDrawerInt", getDrawerEl() || cartBody);
    safeCall("cartNoteUpdate", cartBody);

    setupQuickCartItemsObserver();

    lastSignature = null;
    scheduleRender(true);
  }

  function updateCartDrawerFromSectionHtml(sectionHtml) {
    if (!sectionHtml) return false;

    var parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
    var updatedSection = parsed.querySelector(".shopify-section") || parsed;
    var updatedWrapper = updatedSection.querySelector("[data-cart-wrapper]");
    var cartBody = getCartDrawerBody();

    if (!updatedWrapper || !cartBody) return false;

    closeUpsellVariantDropups();
    closeUpsellModals();

    cartBody.innerHTML = updatedSection.innerHTML;

    var freshWrapper = cartBody.querySelector("[data-cart-wrapper]");
    var itemCount = parseInt((freshWrapper && freshWrapper.getAttribute("data-item-count")) || "0", 10);

    reinitCartDrawer(cartBody, itemCount);

    var drawer = getDrawerEl();
    if (drawer) {
      drawer.classList.add("sd-sidebar--visible");
      document.body.classList.add("no-scroll");
    }

    return true;
  }

  function fetchRenderedCartSection(sectionId) {
    var url = getShopRoot() + "?sections=" + encodeURIComponent(sectionId);

    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (sections) {
        if (sections && sections[sectionId]) {
          updateCartDrawerFromSectionHtml(sections[sectionId]);
        }
      })
      .catch(function () {});
  }

  function addUpsellToCart(variantId) {
    var sectionId = getCartSectionId();
    var url = getShopRoot() + "cart/add.js";

    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: [sectionId],
        sections_url: window.location.pathname
      }),
      credentials: "same-origin"
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response && response.status) throw response;

        if (response && response.sections && response.sections[sectionId]) {
          if (updateCartDrawerFromSectionHtml(response.sections[sectionId])) return;
        }

        return fetchRenderedCartSection(sectionId);
      });
  }

  function isElementVisible(el) {
    if (!el) return false;

    if (el.classList && el.classList.contains("quick-cart__wrapper") && !el.classList.contains("active")) {
      return false;
    }

    var ah = el.getAttribute && el.getAttribute("aria-hidden");
    if (ah === "true") return false;

    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if (cs) {
      if (cs.display === "none" || cs.visibility === "hidden" || Number(cs.opacity) === 0) return false;
    }

    var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    if (!r) return true;

    return r.width > 0 && r.height > 0;
  }

  function destroyUpsellsSwiper(root) {
    if (!root) return;

    if (root._upsellsSwiper && typeof root._upsellsSwiper.destroy === "function") {
      try { root._upsellsSwiper.destroy(true, true); } catch (e) {}
    }

    root._upsellsSwiper = null;
  }

  function initUpsellsSwiper(root) {
    if (!root || !window.Swiper) return;

    var swiperEl = root.querySelector("[data-upsells-swiper]");
    var wrapper = root.querySelector("[data-cart-upsells-list]");
    var previousButton = root.querySelector("[data-upsells-prev]");
    var nextButton = root.querySelector("[data-upsells-next]");

    if (!swiperEl || !wrapper) return;

    var slidesCount = wrapper.querySelectorAll(".swiper-slide").length;

    if (!slidesCount) {
      destroyUpsellsSwiper(root);
      return;
    }

    destroyUpsellsSwiper(root);

    var swiperOptions = {
      slidesPerView: 1.25,
      spaceBetween: 6,
      speed: 300,
      watchOverflow: true,
      centeredSlides: false,

      allowTouchMove: true,
      simulateTouch: true,
      touchEventsTarget: "container",
      touchRatio: 1.35,
      threshold: 3,
      touchAngle: 65,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.12,
      longSwipesMs: 220,
      followFinger: true,
      resistance: true,
      resistanceRatio: 0.65,
      nested: true,
      passiveListeners: false,

      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,

      noSwiping: true,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: "select, option, input, textarea, button, [data-upsell-variant-select], [data-upsell-custom-select], .cart-upsells__variant-row",

      observer: true,
      observeParents: true,
      observeSlideChildren: false
    };

    if (previousButton && nextButton) {
      swiperOptions.navigation = {
        prevEl: previousButton,
        nextEl: nextButton
      };
    }

    root._upsellsSwiper = new window.Swiper(swiperEl, swiperOptions);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === "number" ? precision : 2;
    thousands = typeof thousands === "string" ? thousands : ",";
    decimal = typeof decimal === "string" ? decimal : ".";

    if (isNaN(number) || number === null) return "0";

    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split(".");
    var dollars = parts[0];
    var cents = parts[1] ? decimal + parts[1] : "";
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(dollars)) {
      dollars = dollars.replace(rgx, "$1" + thousands + "$2");
    }

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format);
    }

    if (typeof cents === "string") cents = cents.replace(".", "");

    var formatString = format || (window.Shopify && window.Shopify.money_format) || "${{amount}}";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : "amount";
    var value = "";

    switch (placeholder) {
      case "amount": value = formatWithDelimiters(cents, 2, ",", "."); break;
      case "amount_no_decimals": value = formatWithDelimiters(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": value = formatWithDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = formatWithDelimiters(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = formatWithDelimiters(cents, 2, " ", "."); break;
      case "amount_no_decimals_with_space_separator": value = formatWithDelimiters(cents, 0, " ", "."); break;
      case "amount_with_period_and_space_separator": value = formatWithDelimiters(cents, 2, " ", "."); break;
      case "amount_with_apostrophe_separator": value = formatWithDelimiters(cents, 2, "'", "."); break;
      default: value = formatWithDelimiters(cents, 2, ",", "."); break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; });
  }

  function cartSignature(cart) {
    if (!cart || !cart.items) return "";

    var ids = cart.items.map(function (i) {
      return i.product_id + "x" + i.quantity;
    }).join("|");

    return cart.item_count + "::" + ids;
  }

  function getShopRoot() {
    var root = "/";

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }

    return root.replace(/\/?$/, "/");
  }

  function getRecommendationsUrl(productId, intent, limit) {
    var base = getShopRoot();

    return (
      base +
      "recommendations/products.json?product_id=" + encodeURIComponent(productId) +
      "&intent=" + encodeURIComponent(intent) +
      "&limit=" + encodeURIComponent(limit * 3)
    );
  }

  function fetchRecommendationsForProduct(productId, intent, limit) {
    var url = getRecommendationsUrl(productId, intent, limit);

    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }

  function getCustomProductsFromRoot(root) {
    if (!root) return [];

    var script = root.querySelector("[data-upsells-custom-products]");
    if (!script) return [];

    var raw = script.textContent || "[]";

    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function buildUpsellPriceHtml(price, compareAt, moneyFormat, root) {
    var actualPrice = parseInt(price || "0", 10);
    var regularPrice = parseInt(compareAt || "0", 10);
    var valuesHtml = '<div class="cart-upsells__price-values">' +
      '<span class="cart-upsells__price-regular">' + formatMoney(actualPrice, moneyFormat) + "</span>";

    if (!regularPrice || regularPrice <= actualPrice) return valuesHtml + "</div>";

    var saving = regularPrice - actualPrice;
    var percentage = Math.round((saving * 100) / regularPrice);
    var offText = (root && root.getAttribute("data-upsells-off-text")) || "OFF";
    var saveTemplate = (root && root.getAttribute("data-upsells-save-template")) || "Save __amount__";
    var saveText = saveTemplate.replace("__amount__", formatMoney(saving, moneyFormat));

    return valuesHtml +
      '<span class="cart-upsells__price-old">' + formatMoney(regularPrice, moneyFormat) + "</span>" +
      "</div>" +
      '<div class="cart-upsells__badges">' +
      '<span class="cart-upsells__discount-badge">' + percentage + "% " + offText + "</span>" +
      '<span class="cart-upsells__save-badge">' + saveText + "</span>" +
      "</div>";
  }

  function updateUpsellPriceFromSelect(selectEl) {
    if (!selectEl) return;

    var card = selectEl.closest(".cart-upsells__item");
    if (!card) return;

    var priceWrap = card.querySelector(".cart-upsells__price");
    if (!priceWrap) return;

    var root = card.closest("[data-cart-upsells-root]");
    var moneyFormat =
      (root && root.getAttribute("data-upsells-money-format")) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    var opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    var price = parseInt(opt.getAttribute("data-price") || "0", 10);
    var compareAt = parseInt(opt.getAttribute("data-compare-at") || "0", 10);

    priceWrap.innerHTML = buildUpsellPriceHtml(price, compareAt, moneyFormat, root);
  }

  function buildCardsHtml(products, inCartProductIds, moneyFormat, limit, root, displayMode) {
    var usedIds = new Set();
    var picked = [];

    products.forEach(function (p) {
      if (!p || p.available === false) return;
      if (inCartProductIds.indexOf(p.id) !== -1) return;
      if (usedIds.has(p.id)) return;
      if (picked.length >= limit) return;

      usedIds.add(p.id);
      picked.push(p);
    });

    if (!picked.length) return "";

    return picked.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]);
      var imgUrl = null;

      if (img && typeof img === "string") {
        imgUrl = img.replace(/_(\d+x\d+|x\d+)\./, "_160x.");
      } else if (img && img.src) {
        imgUrl = img.src;
      }

      var title = p.title || "";
      var words = title.split(" ").filter(function (w) { return w.length; });
      var shortTitle = words.slice(0, 5).join(" ");
      if (words.length > 5) shortTitle += "…";

      var variants = p.variants || [];
      var fav = null;

      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) {
          fav = variants[i];
          break;
        }
      }

      if (!fav && variants.length) fav = variants[0] || null;

      var selectedVariant = fav || null;
      var basePrice = selectedVariant && selectedVariant.price != null ? selectedVariant.price : p.price;
      var baseCompareAt = selectedVariant && selectedVariant.compare_at_price != null
        ? selectedVariant.compare_at_price
        : p.compare_at_price;

      var priceHtml = buildUpsellPriceHtml(basePrice, baseCompareAt, moneyFormat, root);

      var hasOnlyDefaultVariant = Boolean(
        p.has_only_default_variant === true ||
        (
          variants.length === 1 &&
          (
            variants[0].title === "Default Title" ||
            variants[0].public_title == null
          )
        )
      );
      var selectedVariantId = selectedVariant && selectedVariant.id;
      var handle = p.handle || "";
      var productUrl = p.url || (handle ? getShopRoot() + "products/" + handle : "#");

      var buttonHtml = "";

      if (hasOnlyDefaultVariant && selectedVariant && selectedVariant.id) {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add data-variant-id="' + selectedVariant.id + '">' +
            '<span class="cart-upsells__add-icon">+</span>' +
            '<span class="cart-upsells__add-spinner" aria-hidden="true"></span>' +
          "</button>";
      } else {
        var quickViewLabel = (root && root.getAttribute("data-upsells-quick-view-label")) || "View details";
        var quickViewAriaLabel = (quickViewLabel + ": " + shortTitle).replace(/"/g, "&quot;");

        buttonHtml =
          '<a href="' + productUrl + '" class="cart-upsells__add quickView-action-link" data-cart-upsell-quick-view aria-label="' + quickViewAriaLabel + '">' +
            '<span class="cart-upsells__add-icon">+</span>' +
            '<span class="cart-upsells__add-spinner" aria-hidden="true"></span>' +
          "</a>";
      }

      var cardHtml =
        '<div class="cart-upsells__item product-item">' +
          '<div class="cart-upsells__row">' +
            '<a href="' + productUrl + '" class="cart-upsells__media" data-instant>' +
              (imgUrl ? '<img src="' + imgUrl + '" alt="' + shortTitle.replace(/"/g, "&quot;") + '">' : "") +
            "</a>" +
            '<div class="cart-upsells__content">' +
              '<a href="' + productUrl + '" class="cart-upsells__title product-title" data-instant>' + shortTitle + "</a>" +
              '<div class="cart-upsells__price">' + priceHtml + "</div>" +
            "</div>" +
            buttonHtml +
          "</div>" +
        "</div>";

      if (displayMode === "modal") return cardHtml;

      return '<div class="swiper-slide">' + cardHtml + "</div>";
    }).join("");
  }

  var lastSignature = null;
  var updating = false;
  var pendingRender = false;
  var pendingForce = false;
  var rafQueued = false;
  var scheduledForce = false;
  var suppressObservers = false;
  var suppressTimer = null;

  function suppressFor(ms) {
    suppressObservers = true;
    clearTimeout(suppressTimer);

    suppressTimer = setTimeout(function () {
      suppressObservers = false;
    }, ms || 180);
  }

  function scheduleRender(force) {
    scheduledForce = scheduledForce || !!force;

    if (rafQueued) return;

    rafQueued = true;

    requestAnimationFrame(function () {
      var forceRender = scheduledForce;

      scheduledForce = false;
      rafQueued = false;
      doRender(forceRender);
    });
  }

  function completeRender() {
    updating = false;

    if (!pendingRender) return;

    var forceRender = pendingForce;

    pendingRender = false;
    pendingForce = false;
    scheduleRender(forceRender);
  }

  function doRender(force) {
    var drawer = getDrawerEl();
    var root = getUpsellsRoot();

    if (!root) return;

    if (!force) {
      if (!isElementVisible(drawer) && !isElementVisible(root)) return;
    }

    if (updating) {
      pendingRender = true;
      pendingForce = pendingForce || !!force;
      return;
    }

    renderCartUpsells(force);
  }

  function renderCartUpsells(force) {
    var root = getUpsellsRoot();

    if (!root) return;

    var listEl = root.querySelector("[data-cart-upsells-list]");
    var modalListEl = root.querySelector("[data-cart-upsells-modal-list]");

    if (!listEl) return;

    updating = true;

    var intent = root.getAttribute("data-upsells-intent") || "complementary";
    var limit = parseInt(root.getAttribute("data-upsells-limit") || "3", 10);
    var moneyFormat =
      root.getAttribute("data-upsells-money-format") ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    fetchCart().then(function (cart) {
      var sig = cartSignature(cart);

      if (sig === lastSignature && listEl.querySelector(".swiper-slide")) {
        completeRender();
        return;
      }

      lastSignature = sig;

      if (!cart || !cart.items || !cart.items.length) {
        suppressFor(150);
        root.style.display = "none";
        closeUpsellVariantDropups();
        closeUpsellModals();
        listEl.innerHTML = "";
        if (modalListEl) modalListEl.innerHTML = "";
        destroyUpsellsSwiper(root);

        completeRender();
        return;
      }

      var inCartProductIds = cart.items.map(function (i) { return i.product_id; });

      function finish(products) {
        var html = buildCardsHtml(products || [], inCartProductIds, moneyFormat, limit, root, "slider");
        var modalHtml = buildCardsHtml(products || [], inCartProductIds, moneyFormat, limit, root, "modal");

        suppressFor(220);

        if (!html) {
          root.style.display = "none";
          closeUpsellVariantDropups();
          closeUpsellModals();
          listEl.innerHTML = "";
          if (modalListEl) modalListEl.innerHTML = "";
          destroyUpsellsSwiper(root);

          completeRender();
          return;
        }

        root.style.display = "";
        closeUpsellVariantDropups();
        listEl.innerHTML = html;
        if (modalListEl) modalListEl.innerHTML = modalHtml;

        var desktopPanel = document.querySelector("[data-upsells-desktop-panel][open]");

        if (desktopPanel) {
          var desktopPanelList = desktopPanel.querySelector("[data-cart-upsells-modal-list]");

          desktopPanel._upsellsRoot = root;
          if (desktopPanelList) desktopPanelList.innerHTML = modalHtml;
          setUpsellsExpanded(root, true);
          safeCall("quickViewElements", desktopPanel);
        }

        root.querySelectorAll("[data-cart-upsell-quick-view]").forEach(function (link) {
          link.addEventListener("click", function () {
            closeUpsellVariantDropups();
            if (!document.querySelector("[data-upsells-desktop-panel][open]")) {
              closeUpsellModals();
            }
          });
        });

        safeCall("quickViewElements", root);

        ensureSwiperLoaded()
          .then(function () {
            initUpsellsSwiper(root);

            setTimeout(function () {
              if (root._upsellsSwiper && typeof root._upsellsSwiper.update === "function") {
                root._upsellsSwiper.update();
              }
            }, 50);
          })
          .catch(function () {});

        completeRender();
      }

      if (intent === "custom") {
        finish(getCustomProductsFromRoot(root));
        return;
      }

      var allRecs = [];
      var productIds = inCartProductIds.slice();
      var idx = 0;

      function step() {
        if (idx >= productIds.length || allRecs.length >= limit * 3) {
          finish(allRecs);
          return;
        }

        var pid = productIds[idx++];

        fetchRecommendationsForProduct(pid, intent, limit)
          .then(function (data) {
            if (data && Array.isArray(data.products)) {
              allRecs = allRecs.concat(data.products);
            }

            step();
          })
          .catch(function () {
            step();
          });
      }

      step();
    }).catch(completeRender);
  }

  function setupQuickCartItemsObserver() {
    var itemsEl = getQuickCartItemsEl();

    if (!itemsEl) return;

    var existing = window.CustomCartUpsellsQCItemsObserver;

    if (existing && existing.el === itemsEl && existing.obs) return;

    if (existing && existing.obs) {
      try { existing.obs.disconnect(); } catch (e) {}
    }

    var obs = new MutationObserver(function (muts) {
      if (suppressObservers) return;

      var root = getUpsellsRoot();

      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (root && t && root.contains(t)) return;
      }

      if (itemsEl.querySelector && itemsEl.querySelector("[data-cart-upsells-root]")) {
        setTimeout(function () {
          lastSignature = null;
          scheduleRender(true);
        }, 0);
      }
    });

    obs.observe(itemsEl, { childList: true, subtree: true });

    window.CustomCartUpsellsQCItemsObserver = { obs: obs, el: itemsEl };
  }

  function setupInsertionObserver() {
    if (window.CustomCartUpsellsInsertionObserver) return;

    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var nodes = m.addedNodes || [];

        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];

          if (!n || n.nodeType !== 1) continue;

          if (
            (n.matches && (n.matches("[data-cart-wrapper]") || n.matches("[data-cart-form]") || n.matches("[data-cart-upsells-root]"))) ||
            (n.querySelector && (n.querySelector("[data-cart-wrapper]") || n.querySelector("[data-cart-form]") || n.querySelector("[data-cart-upsells-root]")))
          ) {
            setupQuickCartItemsObserver();
            scheduleRender(true);
            return;
          }
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    window.CustomCartUpsellsInsertionObserver = obs;
  }

  function setUpsellsSwiperTouch(root, enabled) {
    if (!root || !root._upsellsSwiper) return;

    root._upsellsSwiper.allowTouchMove = enabled;

    if (typeof root._upsellsSwiper.update === "function") {
      root._upsellsSwiper.update();
    }
  }

  function getUpsellsRootFromEventTarget(target) {
    var el = target && target.closest ? target.closest("[data-cart-upsells-root]") : null;
    return el || getUpsellsRoot();
  }

  function getUpsellDropupId(row) {
    if (!row) return "";

    if (!row.getAttribute("data-upsell-dropup-id")) {
      upsellDropupCounter += 1;
      row.setAttribute("data-upsell-dropup-id", "upsell-dropup-" + upsellDropupCounter);
    }

    return row.getAttribute("data-upsell-dropup-id");
  }

  function getRowByDropup(dropdown) {
    if (!dropdown) return null;

    var ownerId = dropdown.getAttribute("data-upsell-dropup-owner");
    if (!ownerId) return null;

    return document.querySelector('[data-upsell-custom-select][data-upsell-dropup-id="' + ownerId + '"]');
  }

  function getDropdownByRow(row) {
    if (!row) return null;

    var rowId = getUpsellDropupId(row);

    return (
      row.querySelector("[data-upsell-variant-dropdown]") ||
      document.querySelector('[data-upsell-variant-dropdown][data-upsell-dropup-owner="' + rowId + '"]')
    );
  }

  function positionUpsellVariantDropup(row) {
    if (!row) return;

    var trigger = row.querySelector("[data-upsell-variant-trigger]");
    var dropdown = getDropdownByRow(row);

    if (!trigger || !dropdown) return;

    var rowId = getUpsellDropupId(row);
    dropdown.setAttribute("data-upsell-dropup-owner", rowId);

    var modal = row.closest("[data-upsells-modal]");
    var dropdownHost = modal || document.body;

    if (dropdown.parentElement !== dropdownHost) {
      dropdownHost.appendChild(dropdown);
    }

    var triggerRect = trigger.getBoundingClientRect();

    dropdown.classList.add("is-open", "is-positioning");

    dropdown.style.setProperty("--upsell-dropdown-width", triggerRect.width + "px");
    dropdown.style.setProperty("--upsell-dropdown-left", triggerRect.left + "px");
    dropdown.style.setProperty("--upsell-dropdown-top", "0px");

    var dropdownHeight = dropdown.offsetHeight || 160;
    var dropdownWidth = dropdown.offsetWidth || triggerRect.width;
    var left = triggerRect.left;
    var top = triggerRect.top - dropdownHeight - 4;

    if (left + dropdownWidth > window.innerWidth - 8) {
      left = window.innerWidth - dropdownWidth - 8;
    }

    if (left < 8) {
      left = 8;
    }

    if (top < 8) {
      top = triggerRect.bottom + 4;
    }

    dropdown.style.setProperty("--upsell-dropdown-left", left + "px");
    dropdown.style.setProperty("--upsell-dropdown-top", top + "px");
    dropdown.style.setProperty("--upsell-dropdown-width", triggerRect.width + "px");

    dropdown.classList.remove("is-positioning");
  }

  function openUpsellVariantDropup(row) {
    if (!row) return;

    var trigger = row.querySelector("[data-upsell-variant-trigger]");
    var dropdown = getDropdownByRow(row);

    if (!trigger || !dropdown) return;

    closeUpsellVariantDropups(row);

    row.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");

    positionUpsellVariantDropup(row);
  }

  function closeUpsellVariantDropups(exceptRow) {
    document.querySelectorAll("[data-upsell-custom-select].is-open").forEach(function (row) {
      if (exceptRow && row === exceptRow) return;

      row.classList.remove("is-open");

      var trigger = row.querySelector("[data-upsell-variant-trigger]");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });

    document.querySelectorAll("[data-upsell-variant-dropdown].is-open").forEach(function (dropdown) {
      var row = getRowByDropup(dropdown);

      if (exceptRow && row === exceptRow) return;

      dropdown.classList.remove("is-open", "is-positioning");

      if (row && dropdown.parentElement !== row) {
        row.appendChild(dropdown);
      }
    });
  }

  function syncUpsellCustomSelectFromNative(select) {
    if (!select) return;

    var row = select.closest("[data-upsell-custom-select]");
    if (!row) return;

    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    var triggerText = row.querySelector("[data-upsell-variant-trigger-text]");

    if (triggerText) {
      triggerText.textContent = selectedOption.textContent;
    }

    var dropdown = getDropdownByRow(row);

    if (!dropdown) return;

    dropdown.querySelectorAll("[data-upsell-variant-option]").forEach(function (button) {
      var isActive = String(button.getAttribute("data-variant-id")) === String(select.value);

      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", isActive ? "true" : "false");
    });
  }

  function isDesktopUpsellsViewport() {
    return window.matchMedia && window.matchMedia("(min-width: 990px)").matches;
  }

  function getUpsellsRootForModal(modal) {
    return (modal && modal._upsellsRoot) ||
      (modal && modal.closest("[data-cart-upsells-root]")) ||
      getUpsellsRoot();
  }

  function setUpsellsExpanded(root, expanded) {
    if (!root) return;

    var button = root.querySelector("[data-upsells-modal-open]");
    if (!button) return;

    var label = button.querySelector("[data-upsells-view-label]");

    button.classList.toggle("is-expanded", expanded);
    button.setAttribute("aria-expanded", expanded ? "true" : "false");

    if (label) {
      label.textContent = expanded
        ? (button.getAttribute("data-upsells-view-less-label") || "View less")
        : (button.getAttribute("data-upsells-view-all-label") || "View all");
    }
  }

  function closeUpsellModal(modal) {
    if (!modal) return;

    var root = getUpsellsRootForModal(modal);

    if (modal.open && typeof modal.close === "function") {
      try { modal.close(); } catch (e) {}
    } else {
      modal.removeAttribute("open");
    }

    if (modal.hasAttribute("data-upsells-desktop-panel")) {
      modal.remove();
    }

    setUpsellsExpanded(root, false);
  }

  function closeUpsellModals() {
    document.querySelectorAll("[data-upsells-modal][open], [data-upsells-desktop-panel]").forEach(closeUpsellModal);
    document.querySelectorAll("[data-cart-upsells-root]").forEach(function (root) {
      setUpsellsExpanded(root, false);
    });
  }

  function openDesktopUpsellsPanel(root, sourceModal) {
    var drawer = root && root.closest("[data-cart-drawer]");
    var drawerContainer = drawer && drawer.querySelector(".sd-sidebar-container");

    if (!drawerContainer || !sourceModal) return false;

    closeUpsellModals();

    var panel = sourceModal.cloneNode(true);
    var panelTitle = panel.querySelector(".cart-upsells__modal-title");

    panel.id = "CartUpsellsDesktopPanel";
    panel.setAttribute("data-upsells-desktop-panel", "");
    panel.setAttribute("aria-labelledby", "CartUpsellsDesktopPanelTitle");
    panel._upsellsRoot = root;

    if (panelTitle) panelTitle.id = "CartUpsellsDesktopPanelTitle";

    drawerContainer.appendChild(panel);

    if (typeof panel.show === "function") {
      panel.show();
    } else {
      panel.setAttribute("open", "");
    }

    setUpsellsExpanded(root, true);
    safeCall("quickViewElements", panel);

    return true;
  }

  document.addEventListener("click", function (event) {
    var openButton = event.target.closest("[data-upsells-modal-open]");
    if (!openButton) return;

    event.preventDefault();

    var root = openButton.closest("[data-cart-upsells-root]");
    var modal = root && root.querySelector("[data-upsells-modal]");

    if (!root || !modal) return;

    var openModal = document.querySelector("[data-upsells-desktop-panel][open]") ||
      root.querySelector("[data-upsells-modal][open]");

    if (openModal) {
      closeUpsellModal(openModal);
      return;
    }

    if (openButton.classList.contains("is-expanded")) {
      setUpsellsExpanded(root, false);
      return;
    }

    if (isDesktopUpsellsViewport()) {
      openDesktopUpsellsPanel(root, modal);
    } else if (typeof modal.showModal === "function") {
      modal.showModal();
      setUpsellsExpanded(root, true);
    }
  });

  document.addEventListener("click", function (event) {
    var closeButton = event.target.closest("[data-upsells-modal-close]");
    if (!closeButton) return;

    event.preventDefault();
    closeUpsellVariantDropups();

    var modal = closeButton.closest("[data-upsells-modal]");
    closeUpsellModal(modal);
  });

  document.addEventListener("click", function (event) {
    var modal = event.target.closest("[data-upsells-modal]");
    if (!modal || event.target !== modal) return;
    if (modal.hasAttribute("data-upsells-desktop-panel")) return;

    closeUpsellVariantDropups();
    closeUpsellModal(modal);
  });

  document.addEventListener("cancel", function (event) {
    if (!event.target.matches("[data-upsells-modal]")) return;
    closeUpsellVariantDropups();
    setUpsellsExpanded(getUpsellsRootForModal(event.target), false);
  });

  document.addEventListener("close", function (event) {
    if (!event.target.matches("[data-upsells-modal]")) return;
    setUpsellsExpanded(getUpsellsRootForModal(event.target), false);
  }, true);

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-cart-drawer] [data-side-drawer-close]")) {
      closeUpsellModals();
    }

    document.querySelectorAll("[data-cart-drawer] details.cart-drawer-item__menu[open]").forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute("open");
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeUpsellModals();
  });

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-upsell-variant-trigger]");
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var row = trigger.closest("[data-upsell-custom-select]");
    if (!row) return;

    var root = getUpsellsRootFromEventTarget(row);
    setUpsellsSwiperTouch(root, false);

    if (row.classList.contains("is-open")) {
      closeUpsellVariantDropups();
    } else {
      openUpsellVariantDropup(row);
    }
  }, true);

  document.addEventListener("click", function (event) {
    var option = event.target.closest("[data-upsell-variant-option]");
    if (!option) return;

    event.preventDefault();
    event.stopPropagation();

    var dropdown = option.closest("[data-upsell-variant-dropdown]");
    var row = getRowByDropup(dropdown);

    if (!row) {
      row = option.closest("[data-upsell-custom-select]");
    }

    if (!row) return;

    var select = row.querySelector("[data-upsell-variant-select]");
    if (!select) return;

    select.value = option.getAttribute("data-variant-id");

    syncUpsellCustomSelectFromNative(select);
    select.dispatchEvent(new Event("change", { bubbles: true }));
    closeUpsellVariantDropups();

    var root = getUpsellsRootFromEventTarget(row);

    setTimeout(function () {
      setUpsellsSwiperTouch(root, true);
    }, 80);
  }, true);

  document.addEventListener("click", function (event) {
    if (
      event.target.closest("[data-upsell-custom-select]") ||
      event.target.closest("[data-upsell-variant-dropdown]")
    ) {
      return;
    }

    closeUpsellVariantDropups();
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeUpsellVariantDropups();

      var root = getUpsellsRoot();

      setTimeout(function () {
        setUpsellsSwiperTouch(root, true);
      }, 80);
    }
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-upsell-custom-select].is-open").forEach(positionUpsellVariantDropup);
  });

  document.addEventListener(
    "scroll",
    function () {
      document.querySelectorAll("[data-upsell-custom-select].is-open").forEach(positionUpsellVariantDropup);
    },
    true
  );

  ["pointerdown", "mousedown", "touchstart"].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var selectArea = event.target.closest("[data-upsell-variant-select], [data-upsell-custom-select], .cart-upsells__variant-row, [data-upsell-variant-dropdown]");
      if (!selectArea) return;

      event.stopPropagation();

      var root = getUpsellsRootFromEventTarget(selectArea);
      setUpsellsSwiperTouch(root, false);
    }, true);
  });

  ["pointerup", "mouseup", "touchend", "touchcancel"].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var root = getUpsellsRootFromEventTarget(event.target);

      setTimeout(function () {
        setUpsellsSwiperTouch(root, true);
      }, 80);
    }, true);
  });

  document.addEventListener("click", function (event) {
    var selectArea = event.target.closest("[data-upsell-variant-select], [data-upsell-custom-select], .cart-upsells__variant-row, [data-upsell-variant-dropdown]");
    if (!selectArea) return;

    event.stopPropagation();

    var root = getUpsellsRootFromEventTarget(selectArea);

    setTimeout(function () {
      setUpsellsSwiperTouch(root, true);
    }, 120);
  }, true);

  document.addEventListener("focusout", function (event) {
    var select = event.target.closest("[data-upsell-variant-select]");
    if (!select) return;

    var root = getUpsellsRootFromEventTarget(select);

    setTimeout(function () {
      setUpsellsSwiperTouch(root, true);
    }, 120);
  });

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-upsell-variant-select]");
    if (!select) return;

    syncUpsellCustomSelectFromNative(select);
    updateUpsellPriceFromSelect(select);

    var root = getUpsellsRootFromEventTarget(select);

    setTimeout(function () {
      setUpsellsSwiperTouch(root, true);
    }, 80);
  });

  function afterCartChange() {
    setTimeout(function () {
      lastSignature = null;
      setupQuickCartItemsObserver();
      scheduleRender(true);
    }, 0);

    setTimeout(function () {
      lastSignature = null;
      scheduleRender(true);
    }, 250);
  }

  var externalCartRefreshTimer = null;

  function scheduleExternalCartRefresh() {
    clearTimeout(externalCartRefreshTimer);
    externalCartRefreshTimer = setTimeout(afterCartChange, 0);
  }

  ["cart:update", "cart:updated", "cart:refresh"].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleExternalCartRefresh);
  });

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-cart-upsell-add]");
    if (!button) return;

    var variantId = button.getAttribute("data-variant-id");

    if (!variantId) {
      var card = button.closest(".cart-upsells__item");

      if (card) {
        var select = card.querySelector("[data-upsell-variant-select]");
        if (select) variantId = select.value;
      }
    }

    if (!variantId) return;

    event.preventDefault();
    event.stopPropagation();

    button.disabled = true;
    button.classList.add("is-loading");

    addUpsellToCart(variantId)
      .then(function () {
        button.disabled = false;
        button.classList.remove("is-loading");

        try {
          document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
          document.dispatchEvent(new CustomEvent("cart:updated"));
        } catch (e) {}

        afterCartChange();
      })
      .catch(function (error) {
        button.disabled = false;
        button.classList.remove("is-loading");

        var card = button.closest(".cart-upsells__item");

        if (card) {
          card.setAttribute("data-upsell-error", (error && (error.description || error.message)) || "Could not add item");
        }
      });
  });

  setupInsertionObserver();
  setupQuickCartItemsObserver();
  scheduleRender(true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setupInsertionObserver();
      setupQuickCartItemsObserver();
      scheduleRender(true);
    });
  }
})();
